export function clickOnEnter() {
    const buttonComponent = [...document.getElementsByTagName("button")].pop();
    if(buttonComponent) {
        window.document.addEventListener('keyup', (e) => {
            if(e.key === "Enter") buttonComponent.click();
        })
    }
}